import { Navigate, useSearchParams } from "react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import { pathWithSearchParams } from "@/lib/navigationPath";
import { useAuthStore } from "@/store/authStore";
import { Permission } from "@/types";
import AdminTicketsPage from "@/pages/admin/tickets";

export default function AdminTicketsIndexRoute() {
  const [searchParams] = useSearchParams();
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const tab = searchParams.get("tab");

  if (tab === "chats") {
    return (
      <Navigate
        to={pathWithSearchParams("/admin/chats", searchParams, {
          omit: ["tab"],
        })}
        replace
      />
    );
  }

  if (
    !hasPermission(Permission.SUPPORT_TICKETS_READ_ANY) &&
    hasPermission(Permission.CUSTOMER_SUPPORT_CHATS_READ_ANY)
  ) {
    return <Navigate to="/admin/chats" replace />;
  }

  return (
    <ProtectedRoute requirePermission={Permission.SUPPORT_TICKETS_READ_ANY}>
      <AdminTicketsPage />
    </ProtectedRoute>
  );
}
